import React, { useCallback } from "react";
import { useFormikContext } from "formik";
import { CheckboxField } from "@td/ui";
import { translate } from "@td/shared_utils";
import { fieldTypes, defaultTaskFormValues } from "../constants";

const NotConsultRelatedField = React.memo(() => {
  const { setFieldValue } = useFormikContext();

  const handleChange = useCallback(() => {
    setFieldValue(fieldTypes.CONSULT_ID, defaultTaskFormValues[fieldTypes.CONSULT_ID], false);
    setFieldValue(fieldTypes.MEMBER, defaultTaskFormValues[fieldTypes.MEMBER], false);
    setFieldValue(fieldTypes.GROUP, defaultTaskFormValues[fieldTypes.GROUP], false);
    setFieldValue(fieldTypes.PROVIDER, defaultTaskFormValues[fieldTypes.PROVIDER], false);
  }, [setFieldValue]);

  return (
    <CheckboxField
      name={fieldTypes.NOT_CONSULT_RELATED}
      onChange={handleChange}
      label={translate(null, "care_team_tasks.form.fields.not_consult_related", "label")}
    />
  );
});

export default NotConsultRelatedField;
